import React from "react";

export class Lightbox extends React.Component {
	
	render() {
		const title = this.props.styleName + (
			this.props.variantName ? " "+this.props.variantName : ""
		);

		return (
			<div className="lightbox" onClick={this.props.onClick}>
				<button className="close-button" onClick={this.props.onClick}>✕</button>
				{
					this.props.images.map( (image, i) => <img
						className="lightbox-image"
						src={image.full}
						alt={`Example for ${title} style`}
						onClick={e=>e.stopPropagation()}
						key={i}
						/> )
				}
			</div>
		);
	}
}